import { render } from "./SelectProductColumn.vue?vue&type=template&id=d09da552"
import script from "./SelectProductColumn.vue?vue&type=script&lang=js"
export * from "./SelectProductColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__